import React from 'react';
import { Badge } from '../ui/Badge';
import { cn } from '../../lib/utils';
import { Users } from 'lucide-react';

interface OrgCardProps {
  name: string;
  slug: string;
  role: string;
  memberCount: number;
  unreadCount: number;
  primaryColor?: string;
  onClick: () => void;
}

export const OrgCard: React.FC<OrgCardProps> = ({
  name,
  slug,
  role,
  memberCount,
  unreadCount,
  primaryColor = '#0F1F3D',
  onClick,
}) => {
  const initials = (name || '').substring(0, 2).toUpperCase();

  return (
    <div
      onClick={onClick}
      className="bg-white border-2 border-black dark:border-white rounded-none p-4 flex items-center gap-3 cursor-pointer hover:shadow-[4px_4px_0px_#000000] dark:shadow-[4px_4px_0px_#FFFFFF] transition-shadow relative group dark:bg-slate-900"
    >
      {unreadCount > 0 && (
        <div className="absolute -top-2 -right-2">
          <Badge variant="red" className="px-1.5 min-w-[20px] justify-center shadow-[4px_4px_0px_#000000] dark:shadow-[4px_4px_0px_#FFFFFF]">
            {unreadCount}
          </Badge>
        </div>
      )}

      <div
        className="w-10 h-10 rounded-none flex items-center justify-center text-sm font-bold text-white flex-shrink-0"
        style={{ backgroundColor: primaryColor }}
      >
        {initials}
      </div>

      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 mb-0.5">
          <h3 className="text-sm font-semibold text-gray-900 truncate dark:text-white">{name}</h3>
          <Badge variant={role === 'OWNER' || role === 'ADMIN' ? 'navy' : 'blue'}>
            {role}
          </Badge>
        </div>
        <div className="flex items-center gap-1 text-xs text-gray-500">
          <Users size={12} />
          <span>{(memberCount ?? 0).toLocaleString()} members</span>
        </div>
      </div>
    </div>
  );
};

export const AddOrgCard: React.FC<{ onClick?: () => void }> = ({ onClick }) => (
  <div
    onClick={onClick}
    className="border-2 border-dashed border-black dark:border-white rounded-none p-4 flex items-center justify-center gap-2 cursor-pointer hover:border-black dark:border-white hover:bg-white transition-all group dark:bg-slate-950"
  >
    <div className="w-8 h-8 rounded-none bg-white flex items-center justify-center text-gray-400 group-hover:text-gray-600 transition-colors dark:bg-slate-800">
      <span className="text-xl font-light">+</span>
    </div>
    <span className="text-sm font-medium text-gray-500 group-hover:text-gray-700">Add or join org</span>
  </div>
);
